import { getRouteApi } from '@tanstack/react-router';
import * as React from 'react';

import { useAuthRefresh } from '@/auth/auth-context';
import {
  MagicLinkScreen,
  type MagicLinkOutcome,
} from '@/routes/onboarding/magic-link-screen';

// =============================================================================
// magic-link-route.tsx — Adaptateur routeur de l'écran F-01 (consommation token).
// =============================================================================
// Lit le token de connexion depuis le path param d'URL (`/onboarding/$token`,
// TanStack Router) et, à l'activation réussie, route vers la suite de
// l'onboarding : CGU (F-02) si non signées, tableau de bord fournisseur (§3.2,
// `/dashboard`) sinon (EF-IDA-4). Le statut CGU (`hasSigned`) est résolu par le
// screen via legal.hasSigned() (BC legal) — la route ne fait que naviguer. Le
// token vit dans l'URL (pas de localStorage, RULE_REF_006) — le lien e-mail EST
// l'URL.

const routeApi = getRouteApi('/onboarding/$token');

export function MagicLinkRoute(): React.JSX.Element {
  const { token } = routeApi.useParams();
  const navigate = routeApi.useNavigate();
  // S0-ROLE : la consommation du magic-link a ouvert une NOUVELLE session fournisseur (cookie httpOnly).
  // On re-résout l'identité (whoami + me) AVANT de naviguer, pour que l'AuthState porte role:'supplier'
  // dès l'arrivée sur '/dashboard' ou '/cgu' (sinon la nav resterait en interim admin). NO-OP hors
  // bootstrap.
  const { refresh } = useAuthRefresh();

  const onActivated = React.useCallback(
    async (outcome: MagicLinkOutcome): Promise<void> => {
      await refresh();
      // DBU §3.1 l.2414-2418 / §3.2 : destination post-connexion = tableau de bord fournisseur,
      // JAMAIS '/' (landing/auth ADMIN, §2.1 l.514/574 — séparation ferme des mondes, §1.3 l.374).
      void navigate({
        to: outcome.hasSigned ? '/dashboard' : '/cgu',
      });
    },
    [navigate, refresh],
  );

  return <MagicLinkScreen token={token} onActivated={onActivated} />;
}
